<template>
    <Layout>
        <div class="max-w-4xl mx-auto text-center pt-8">
            <h1 class="text-3xl text-left pl-4">Downloads</h1>
            <br>
            <div class="text-left pl-4">
                <ul>
                    <li v-for="download in downloadForms" :key="download.id">
                        <h1 class="text-xl font-bold pb-4">{{ download.title }} <a class="underline text-blue-600 hover:text-blue-800" target="_blank" :href="download.downloadForm?.data?.attributes?.url">Download</a></h1> 
                        <p class="text-l pb-4">{{ download.description }}</p>
                    </li>
                </ul>
            </div>
        </div>
    </Layout>
</template>
<script>
import Layout from './../layouts/LayoutView.vue'
import axiosInstance from '@/utils/axiosInstance';


export default {
  components: {
    Layout
  },
  data() {
    return {
        downloadForms: [],
    };
  },
  computed: {
  },
  async created() {
    try {
      const response = await axiosInstance.get('download-form?populate[downloadForm][populate]=*'); 
      var responseAttributes = response.data.data.attributes;
      this.downloadForms = responseAttributes.downloadForm;

    } catch (error) {
      console.error('Failed to fetch About Us Page:', error);
      
    }
  },
}
</script>
